var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { GuestGeneralInfoService } from './guest-general-info.service';
import { ImsService } from '../../ims.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { resolveDomainValidationErrorMessage, resolveDomainValidationSuccessMessage, } from 'src/app/shared/domain-validation/domain-validation-messages';
var GUEST_PROFILE_TYPE = 'guest';
var GuestGeneralInfoComponent = /** @class */ (function () {
    function GuestGeneralInfoComponent(dialog, guestGeneralInfoService, imsService, toasterService, datePipe) {
        this.dialog = dialog;
        this.guestGeneralInfoService = guestGeneralInfoService;
        this.imsService = imsService;
        this.toasterService = toasterService;
        this.datePipe = datePipe;
        this.info = {};
        this.referralSummary = {};
        this.lifetimeRides = null;
        this.guestDetails = null;
        this.showEmailDialog = false;
        this.showDeleteEmailDialog = false;
        this.newEmail = '';
        this.updatingEmail = false;
        this.deletingEmail = false;
        this.errorMsg = '';
        this.domainType = '';
        this.domainTypeLookupLoading = false;
        this.domainTypeOptions = ['corporate', 'non_corporate'];
        this.deleteErrorMsg = '';
        this.showNameDialog = false;
        this.newName = '';
        this.updatingName = false;
        this.nameErrorMsg = '';
    }
    GuestGeneralInfoComponent.prototype.ngOnChanges = function (changes) {
        if (changes.data && changes.data.currentValue) {
            this.data = changes.data.currentValue;
            if (this.data.dataFetched) {
                this.fetchReferralSummaryAndConstruct();
            }
            else {
                this.blankCard();
            }
        }
        else {
            this.emptyCard();
        }
    };
    GuestGeneralInfoComponent.prototype.ngOnInit = function () { };
    GuestGeneralInfoComponent.prototype.blankCard = function () {
        this.info = {
            header: 'General Info',
            data: [],
            dataFetched: false
        };
    };
    GuestGeneralInfoComponent.prototype.emptyCard = function () {
        this.info = {
            header: 'General Info',
            dataFetched: false,
            data: null
        };
    };
    GuestGeneralInfoComponent.prototype.fetchReferralSummaryAndConstruct = function () {
        var _this = this;
        var guestProfileData = this.data.profiles.filter(function (profile) { return profile.type === GUEST_PROFILE_TYPE; })[0];
        if (!guestProfileData) {
            this.blankCard();
            return;
        }
        var referralComplete = false;
        this.guestDetails = null;
        this.guestGeneralInfoService.getGuestDetails(guestProfileData.id).subscribe(function (result) {
            _this.guestDetails = result && result.guests && result.guests.length > 0 ? result.guests[0] : null;
            if (referralComplete) {
                _this.constructCard();
            }
        }, function (error) {
            console.error('Error fetching guest details:', error);
            _this.guestDetails = null;
            if (referralComplete) {
                _this.constructCard();
            }
        });
        this.guestGeneralInfoService.getReferralSummary(guestProfileData.id).subscribe(function (result) {
            _this.referralSummary = result || {};
            referralComplete = true;
            _this.constructCard();
        }, function (error) {
            console.error('Error fetching referral summary:', error);
            _this.referralSummary = {};
            referralComplete = true;
            _this.constructCard();
        });
        this.guestGeneralInfoService.getLifetimeRides(guestProfileData.id).subscribe(function (result) {
            _this.lifetimeRides = result || null;
            if (referralComplete) {
                _this.constructCard();
            }
        }, function (error) {
            console.error('Error fetching lifetime rides:', error);
            _this.lifetimeRides = null;
            if (referralComplete) {
                _this.constructCard();
            }
        });
    };
    GuestGeneralInfoComponent.prototype.constructCard = function () {
        if (this.data && this.data.dataFetched) {
            var guestProfileData = this.data.profiles.filter(function (profile) { return profile.type === GUEST_PROFILE_TYPE; })[0];
            if (!guestProfileData) {
                this.blankCard();
                return;
            }
            var cityName = this.getCityName();
            this.info = {
                header: 'General Info',
                dataFetched: true,
                data: [
                    {
                        header: 'Name',
                        value: this.data.name,
                        className: 'id-icon',
                        svgIcon: true,
                        actionMenuItems: [
                            { label: 'Edit Name', event: 'Edit Name' }
                        ]
                    },
                    { header: 'Gender', value: this.data.gender, className: 'id-icon', svgIcon: true }
                ].concat((cityName ? [{ header: 'City', value: cityName, className: 'id-icon', svgIcon: true }] : []), [
                    {
                        header: 'Email',
                        value: guestProfileData.email,
                        className: 'email-id-icon',
                        svgIcon: true,
                        actionMenuItems: this.getEmailActionMenuItems(guestProfileData.email)
                    },
                    { header: 'LTR', value: this.getLtrValue(), className: 'id-icon', svgIcon: true }
                ], (this.referralSummary.myReferralCode ? [{ header: 'My Referral Code', value: this.referralSummary.myReferralCode, svgIcon: true, className: 'referral-code-icon' }] : []), (this.referralSummary.referredBy && this.referralSummary.referredBy.name ? [__assign({ header: 'Referred By', value: this.referralSummary.referredBy.mobile ? this.referralSummary.referredBy.name + " (" + this.referralSummary.referredBy.mobile + ")" : this.referralSummary.referredBy.name, svgIcon: true, className: 'referral-code-icon' }, (this.referralSummary.referredBy.role && this.referralSummary.referredBy.mobile ? { redirectLink: "/" + this.referralSummary.referredBy.role.toLowerCase() + "/" + this.referralSummary.referredBy.mobile } : {}))] : []), (this.referralSummary.referredBy && this.referralSummary.referredBy.code ? [{ header: 'Referred By Code', value: this.referralSummary.referredBy.code, svgIcon: true, className: 'referral-code-icon' }] : []), (this.referralSummary.referredAt ? [{ header: 'Referred At', value: this.formatDate(this.referralSummary.referredAt), svgIcon: true, className: 'referral-code-icon' }] : []), (this.referralSummary.referredRewardAchievedAt ? [{ header: 'Referral Reward At', value: this.formatDate(this.referralSummary.referredRewardAchievedAt), svgIcon: true, className: 'referral-code-icon' }] : []))
            };
        }
    };
    GuestGeneralInfoComponent.prototype.formatDate = function (dateStr) {
        if (!dateStr) {
            return 'N/A';
        }
        return this.datePipe.transform(dateStr, 'mediumDate') || 'N/A';
    };
    GuestGeneralInfoComponent.prototype.getCityName = function () {
        var guest = this.guestDetails;
        if (!guest) {
            return '';
        }
        var cityData = guest.cityData || guest.city || (guest.profileData && (guest.profileData.cityData || guest.profileData.city));
        if (!cityData) {
            return '';
        }
        if (typeof cityData === 'string') {
            return cityData;
        }
        return cityData.name || cityData.displayName || cityData.cityName || '';
    };
    GuestGeneralInfoComponent.prototype.getLtrValue = function () {
        if (this.lifetimeRides && typeof this.lifetimeRides.totalDroppedRides === 'number') {
            return String(this.lifetimeRides.totalDroppedRides);
        }
        return 'N/A';
    };
    GuestGeneralInfoComponent.prototype.getEmailActionMenuItems = function (email) {
        var menuItems = [{ label: 'Edit Email', event: 'Edit Email' }];
        if (email) {
            menuItems.push({ label: 'Delete Email', event: 'Delete Email' });
        }
        return menuItems;
    };
    GuestGeneralInfoComponent.prototype.eventTriggered = function (value) {
        if (value === 'Edit Email') {
            this.errorMsg = '';
            this.newEmail = '';
            this.resetDomainTypeSelection();
            this.showEmailDialog = true;
        }
        else if (value === 'Delete Email') {
            this.deleteErrorMsg = '';
            this.showDeleteEmailDialog = true;
        }
        else if (value === 'Edit Name') {
            this.nameErrorMsg = '';
            this.newName = '';
            this.showNameDialog = true;
        }
    };
    GuestGeneralInfoComponent.prototype.closeEmailDialog = function () {
        if (this.updatingEmail) {
            return;
        }
        this.showEmailDialog = false;
        this.newEmail = '';
        this.resetDomainTypeSelection();
        this.errorMsg = '';
    };
    GuestGeneralInfoComponent.prototype.resetDomainTypeSelection = function () {
        this.domainType = '';
        this.domainTypeLookupLoading = false;
    };
    GuestGeneralInfoComponent.prototype.canLookupEmail = function () {
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        return trimmedEmail.indexOf('@') > 0;
    };
    GuestGeneralInfoComponent.prototype.lookupEmailDomain = function () {
        var _this = this;
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!trimmedEmail || trimmedEmail.indexOf('@') <= 0) {
            this.resetDomainTypeSelection();
            return;
        }
        this.domainTypeLookupLoading = true;
        this.imsService.lookupEmailDomain(trimmedEmail).subscribe({
            next: function (response) {
                _this.domainTypeLookupLoading = false;
                if (response && response.exists && response.domainType) {
                    _this.domainType = response.domainType;
                }
                else {
                    _this.domainType = '';
                }
            },
            error: function () {
                _this.domainTypeLookupLoading = false;
                _this.domainType = '';
            }
        });
    };
    GuestGeneralInfoComponent.prototype.submitEmail = function () {
        var _this = this;
        if (!this.data || !this.data.profiles) {
            return;
        }
        var guestProfile = this.data.profiles.find(function (profile) { return profile.type === GUEST_PROFILE_TYPE; });
        var trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!guestProfile || !trimmedEmail) {
            this.errorMsg = 'Please enter a valid email.';
            return;
        }
        if (!this.domainType) {
            this.errorMsg = 'Please select a domain type.';
            return;
        }
        this.updatingEmail = true;
        this.errorMsg = '';
        this.imsService.updateUserEmail(this.data.id, trimmedEmail, [GUEST_PROFILE_TYPE], this.domainType).subscribe({
            next: function (res) {
                guestProfile.email = trimmedEmail;
                _this.constructCard();
                _this.showEmailDialog = false;
                _this.newEmail = '';
                _this.updatingEmail = false;
                var successCopy = resolveDomainValidationSuccessMessage(res) ||
                    'Email updated successfully.';
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: successCopy
                }));
            },
            error: function (err) {
                _this.updatingEmail = false;
                _this.errorMsg = resolveDomainValidationErrorMessage(err);
            }
        });
    };
    GuestGeneralInfoComponent.prototype.closeDeleteEmailDialog = function () {
        if (this.deletingEmail) {
            return;
        }
        this.showDeleteEmailDialog = false;
        this.deleteErrorMsg = '';
    };
    GuestGeneralInfoComponent.prototype.deleteEmail = function () {
        var _this = this;
        if (!this.data || !this.data.id) {
            return;
        }
        this.deletingEmail = true;
        this.deleteErrorMsg = '';
        this.imsService.deleteUserEmail(this.data.id).subscribe({
            next: function () {
                _this.showDeleteEmailDialog = false;
                _this.deletingEmail = false;
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Email deleted successfully.'
                }));
                window.location.reload();
            },
            error: function (err) {
                _this.deletingEmail = false;
                _this.deleteErrorMsg = (err && err.error && err.error.metadata && err.error.metadata.error &&
                    err.error.metadata.error.displayMessage) || 'Failed to delete email';
            }
        });
    };
    GuestGeneralInfoComponent.prototype.closeNameDialog = function () {
        if (this.updatingName) {
            return;
        }
        this.showNameDialog = false;
        this.newName = '';
        this.nameErrorMsg = '';
    };
    GuestGeneralInfoComponent.prototype.submitName = function () {
        var _this = this;
        if (!this.data) {
            return;
        }
        if (!this.newName || !this.newName.trim()) {
            this.nameErrorMsg = 'Please enter a valid name.';
            return;
        }
        this.updatingName = true;
        this.nameErrorMsg = '';
        this.imsService.updateUserName(this.data.id, this.newName.trim()).subscribe({
            next: function () {
                _this.data.name = _this.newName.trim();
                _this.constructCard();
                _this.showNameDialog = false;
                _this.newName = '';
                _this.updatingName = false;
                _this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Name updated successfully.'
                }));
            },
            error: function (err) {
                _this.updatingName = false;
                _this.nameErrorMsg = (err && err.error && err.error.metadata && err.error.metadata.error &&
                    err.error.metadata.error.displayMessage) || 'Failed to update name';
            }
        });
    };
    GuestGeneralInfoComponent.prototype.accessCookie = function (cookieName) {
        var name = cookieName + '=';
        var allCookieArray = document.cookie.split(';');
        for (var i = 0; i < allCookieArray.length; i++) {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name) === 0) {
                return temp.substring(name.length, temp.length);
            }
        }
        return '';
    };
    return GuestGeneralInfoComponent;
}());
export { GuestGeneralInfoComponent };
